import { SuccessModalContent, Modal } from "@ucchub/ui";
import { t } from "i18next";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

interface CustomerConfirmPopupProps {
  showModal: () => void;
  customerName?: string | undefined;
  customerId?: string | undefined;
}

const CustomerUpdatePopup = ({
  customerName,
  customerId,
  showModal,
}: CustomerConfirmPopupProps) => {
  const [showUpdateModal, setShowUpdateModal] = useState(true);
  const navigate = useNavigate();
  return (
    <Modal
      srName={t("core:users:customers")}
      isOpen={showUpdateModal}
      size={2}
      onClose={() => {
        setShowUpdateModal(false);
        navigate("/customers/" + customerId + "/view");
        showModal();
      }}
    >
      <SuccessModalContent
        heading={t(
          "core:customers:confirmation:customer_successfully_created.message"
        )}
        body={t(
          "core:customers:confirmation:customer_successfully_created.message1",
          {
            text: customerName,
          }
        )}
        confirmText={t(
          "core:customers:confirmation:customer_successfully_created.backToDetails"
        )}
        onConfirm={() => {
          navigate("/customers/" + customerId + "/view");
        }}
      />
    </Modal>
  );
};
export default CustomerUpdatePopup;
